__webpack_require__.p = "/react_lezeni/";